'use client';

import { useQuery } from '@tanstack/react-query';
import { curatorQueries } from '../../query-factory';
import { mapProposalDetailToView } from '../components/seedingDetail/adapters';

/**
 * 시딩 제안형 상세 — service DTO 를 `select` 단계에서 presentation `SeedingCampaignDetail` 로 매핑.
 */
export const useSeedingProposalDetail = (campaignId: number | undefined) =>
  useQuery({
    ...curatorQueries.campaigns.seedingProposalDetail({ campaignId: campaignId! }),
    enabled: campaignId !== undefined && campaignId > 0,
    select: mapProposalDetailToView,
  });
